import { CurrentCommunityContextProvider } from "@circle-react/contexts/currentCommunityContext";
import { SpaceGroupsContextProvider } from "@circle-react/contexts/spaceGroupsContext";

import { CreateSpaceModal } from "./CreateSpaceModal";
import type { CreateSpaceModalProps } from "./CreateSpaceModal";

export type CreateSpaceV4Props = CreateSpaceModalProps;

export const CreateSpaceV4 = (props: CreateSpaceV4Props) => (
  <CurrentCommunityContextProvider>
    <SpaceGroupsContextProvider>
      <CreateSpaceModal {...props} />
    </SpaceGroupsContextProvider>
  </CurrentCommunityContextProvider>
);
